import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Shop from "@/pages/Shop";
import { Toaster } from "sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Shop />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-center" />
    </div>
  );
}

export default App;
